import styled from 'styled-components';

export const Container = styled.div`
  margin-bottom: 32px;
`;

export const Title = styled.h1`
  font-size: 32px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px 0;
`;

export const Description = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0;
`;
